"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getBorderColor = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error(_ref) {
  var error = _ref.error,
      warning = _ref.warning,
      className = _ref.className;
  return error || warning ? /*#__PURE__*/_react.default.createElement(ErrorContainer, {
    className: className,
    error: error
  }, /*#__PURE__*/_react.default.createElement("p", null, error || warning)) : null;
};

var ErrorContainer = _styledComponents.default.div.withConfig({
  displayName: "ErrorContainer"
})(["width:100%;display:flex;justify-content:flex-end;margin-top:1rem;margin-bottom:1rem;font-size:1.2rem;color:", ";"], function (_ref2) {
  var theme = _ref2.theme,
      error = _ref2.error;
  return error ? theme.status.error : theme.status.warning;
});

Error.displayName = 'Error';
Error.defaultProps = {
  error: ''
};
Error.propTypes = {
  /** string with errormessage */
  error: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool]),

  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** string with warningmessage */
  warning: _propTypes.string
};

var getBorderColor = function getBorderColor(error, touched, theme, warning) {
  if (error) return theme.status.error;else {
    if (warning) return theme.status.warning;else if (touched) return theme.status.succes;
  }
  return '#e4e4e4';
};

exports.getBorderColor = getBorderColor;
var _default = Error;
exports.default = _default;